
export const editGroupSetDialogBodyStyles: React.CSSProperties = {
    display: 'inline-block',
    width: '100%'
};

export const editGroupSetNameFieldStyles: React.CSSProperties = {
    width: '400px'
};

export const editGroupSetDialogLabelStyles: React.CSSProperties = {
    width: '150px',
};

export const editGroupSetDialogFieldStyles: React.CSSProperties = {
    display: 'inline-flex',
    marginBottom: '21px'
};